export const STYLES = {
  accentBar: "h-2 rounded-t-[10px]",
  header: "px-5 py-4 border-0",
  headerInner: "flex items-center justify-between",
  headerLeft: "flex flex-col justify-center",
  headerRight: "flex items-center gap-3",
  title: "text-sm font-medium text-[#171717] p-0 m-0",
  subtitle: "text-xs text-[#5f6774] p-0 m-0",
  content: "px-0 py-0",
  formGridWithMap: "grid grid-cols-2 gap-4 mb-6",
  formContainer: "flex flex-row gap-8",
  formColumn: "flex-1 w-1/2 space-y-4",
  timeGrid: "grid grid-cols-2 gap-4",
  inputGrid: "grid grid-cols-2 gap-4",
  detailsColumn: "flex-1 w-1/2",
  buttonContainer: "flex justify-between gap-3 mt-6",
  footerContainer: "flex justify-between items-center gap-3 px-5 py-3 min-h-[70px]",
  footerLeft: "flex items-center gap-3",
  footerInput: "w-auto min-w-24 max-w-36",
  headerInput: "w-40",
  headerTimeInput: "w-auto min-w-24 text-right",
  sidebar:
    "w-full md:w-[280px] border-t md:border-t-0 md:border-l border-[#e5e6ec] flex flex-col p-4 gap-4 md:rounded-br-[10px]",
  sidebarHeading: "text-sm font-medium text-[#171717]",
  sidebarSubtext: "text-[10px] text-[#5f6774]",
  sidebarFormGroup: "bg-[#F5F7F9] rounded-[5px] p-2.5 space-y-2",
  sidebarSelect: "h-[30px] text-xs border-[#e5e7eb] rounded-[4px]",
  sidebarNextBtn: "w-full h-[30px] rounded-[5px] text-xs font-normal normal-case",
  selectionChip:
    "flex items-center gap-1.5 h-[26px] bg-[#f4f6f8] border border-[#e5e7eb] rounded-[5px] px-2.5 py-1.5 text-sm font-medium text-[#374151]",
  legend: "flex items-center gap-3",
  legendItem: "flex items-center gap-2",
  legendDot: "w-[7px] h-[7px] rounded-sm",
  legendText: "text-xs text-[#9c9c9c]",
  mobileSheetHeader: "relative flex items-center justify-center px-5 py-4 border-b border-[#e5e7eb]",
  mobileSheetTitle: "text-base font-medium leading-4 text-[#19191b]",
  mobileSheetBackBtn: "absolute left-5 flex h-8 w-8 items-center justify-center rounded-md text-[#171717]",
  mobileSheetCloseBtn: "absolute right-5 flex h-8 w-8 items-center justify-center rounded-md text-[#171717]",
  mobileSheetContent: "flex flex-col flex-1 min-h-0 overflow-y-auto",
  mobileSheetPlanContainer: "h-[340px] min-h-[340px] overflow-hidden flex",
  mobileSheetFormSection: "px-5 py-4 space-y-4",
  mobileSheetFormLabel: "text-xs font-medium text-[#373942] mb-1 block",
  mobileSheetFormInput: "h-10 text-sm border border-[#f1f2f5] rounded-[5px] bg-white",
  mobileSheetFooter: "sticky bottom-0 bg-white px-5 pt-2.5 pb-[30px] border-t border-[#e5e6ec]",
  mobileSheetNextBtn: "w-full h-10 rounded-[10px] bg-[#2596fa] text-base font-medium text-white normal-case",
} as const
